export default __webpack_public_path__ + "static/gallery_xl_2-9c404333cf69f6fba0bd8a9ce2259265.jpg";